<span [popoverTitle]="title|translate" [autoClose]="'outside'" [ngbPopover]="fullText"
  [triggers]="showEvent=='hover'?'mouseenter:mouseleave':''" [placement]="placement">

  <ng-content select="[small-text]"></ng-content>

</span>

<ng-template #fullText>
  <ng-content select="[full-text]"></ng-content>
</ng-template>
